import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/cell/style/index.js
// module id = 402
// module chunks = 0